const Location1 = () => {
  return (
    <>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7669.645087197743!2d-82.729819!3d39.957026!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88386f8487ea6f3b%3A0x79f0d89809191e88!2sPerfect%20Threading%20%26%20Hair%20Salon.!5e1!3m2!1sen!2sbt!4v1744519419702!5m2!1sen!2sbt"
        width="600"
        height="450"
        style={{ border: "0" }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </>
  );
};

const Location2 = () => {
  return (
    <>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3837.584842552515!2d-82.75060048789382!3d39.907738486341415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88387b463a62a74f%3A0x8a94549a2c9b8f79!2s8515%20Refugee%20Rd%2C%20Pickerington%2C%20OH%2043147%2C%20USA!5e1!3m2!1sen!2sca!4v1744737368360!5m2!1sen!2sca"
        width="600"
        height="450"
        style={{ border: "0" }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </>
  );
};

const Location3 = () => {
  return (
    <>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7675.155980047383!2d-82.78714714532406!3d39.90786081326999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88387b26899cafe3%3A0x9015270fa1b42642!2s859%20Windmiller%20Dr%2C%20Pickerington%2C%20OH%2043147%2C%20USA!5e1!3m2!1sen!2sca!4v1744737140416!5m2!1sen!2sca"
        width="600"
        height="450"
        style={{ border: "0" }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </>
  );
};

// Named exports
export { Location1, Location2, Location3 };
